// extracted by mini-css-extract-plugin
module.exports = {"quantity_counter":"quantityCounter_quantity_counter__Qg4gr","button":"quantityCounter_button__Osxpt","input":"quantityCounter_input__2XdUT"};